"use client";
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import UniverBackground from "../components/Background";
import HomeContent from "../components/HomeContent";

const Por = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    document.title = "Endurio · Proof of Reference";
  }, []);

  return (
    <div className="relative flex w-full h-full bg-black">
      <UniverBackground url={url} />
      <Header url={url} setUrl={setUrl} />
      <HomeContent url={url} setUrl={setUrl} />
    </div>
  );
};

export default Por;
